module.exports = __webpack_public_path__ + "img/night-bottom-bg_zh.f2faece5.png";